/**
 * biva.all.js
 * @author Mitsutoshi Nakamura <mitsutoshi.nakamura.jp@gmail.com>
 */

const stellarnav = require('./_stellarnav.js');

class App {
  constructor() {
    console.log('biva.all.js');
    stellarnav.mobileCloseOnTransition();
  }
}

$(() => { const app = new App(); });



// WEBPACK FOOTER //
// ./assets/js/biva.all.js